import { controlPanelRoutePaths } from '../../control-panel/models/path-model';
import { classificationRoutePaths } from '../../classification/models/path-model';
import { dashboardRoutePaths } from '../../dashboard/routes';
import { evaluationPanelPaths } from '../../evaluation-panel/models/path-model';
import { screeningRoutePaths } from '../../screening/models/path-model';
import { Role, RoleModel } from './role-model';

export type MenuItemConfig = {
  label: string;
  to: string;
  routePaths: Record<string, string>;
  roles: RoleModel[];
};

export const USERS_MENU_ITEM = {
  label: 'Usuários',
  roles: [Role.admin],
} as const;

export const MENU_ITEMS: MenuItemConfig[] = [
  {
    label: 'Painel de controle',
    to: controlPanelRoutePaths.cycles,
    routePaths: controlPanelRoutePaths,
    roles: [Role.admin],
  },
  {
    label: 'Triagem',
    to: screeningRoutePaths.storiesList,
    routePaths: screeningRoutePaths,
    roles: [Role.admin, Role.externalAgency],
  },
  {
    label: 'Classificação',
    to: classificationRoutePaths.storiesList,
    routePaths: classificationRoutePaths,
    roles: [Role.admin, Role.externalAgency],
  },
  {
    label: 'Dashboard',
    to: dashboardRoutePaths.dashboard,
    routePaths: dashboardRoutePaths,
    roles: [Role.admin, Role.stateManager],
  },
  {
    label: 'Banca avaliadora',
    to: evaluationPanelPaths.list.replace(':id?', ''),
    routePaths: evaluationPanelPaths,
    roles: [Role.evaluator, Role.admin],
  },
];
